import { render, staticRenderFns } from "./EcommerceCompanyTable.vue?vue&type=template&id=b43d1d46&scoped=true&"
import script from "./EcommerceCompanyTable.vue?vue&type=script&lang=js&"
export * from "./EcommerceCompanyTable.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceCompanyTable.vue?vue&type=style&index=0&id=b43d1d46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43d1d46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b43d1d46')) {
      api.createRecord('b43d1d46', component.options)
    } else {
      api.reload('b43d1d46', component.options)
    }
    module.hot.accept("./EcommerceCompanyTable.vue?vue&type=template&id=b43d1d46&scoped=true&", function () {
      api.rerender('b43d1d46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ecommerce/EcommerceCompanyTable.vue"
export default component.exports